import './i18n/i18n';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ChannelContextProvider from './context/channel';


ReactDOM.render(
  <ChannelContextProvider>
    <App />
  </ChannelContextProvider>,
  document.getElementById('root')
);

